$(document).ready(function () {
    $(document).on('click', '.js__add_to_wishlist', function () {
        const btn = $(this);
        const id = btn.attr('data-id');
        let wrapper = '';

        if (typeof is_page_wishlist != 'undefined') {
            wrapper = btn.closest('.js_card');
        }

        $.post(requests.postAddWishList, {
            'good_id': id,
            'lang': lang,
        }, function (data) {
            if (data.status == 'success') {
                if (btn.hasClass('active')) {
                    btn.removeClass('active');

                    if (typeof is_page_wishlist != 'undefined') {
                        wrapper.remove();
                    }
                } else {
                    btn.addClass('active');

                    if (!data.user) {
                        viewModalWishlist();
                    }
                }
            }

            if (data.status == 'error') {

            }
        })
    });

    function viewModalWishlist() {
        // Показать модальное окно что сохранили на месяц
        console.log('Мы туть')
    }
})